import React from 'react';

import { Entity, RELATION_OWNED_BY } from '@backstage/catalog-model';
import { MarkdownContent } from '@backstage/core-components';
import {
  EntityRefLinks,
  getEntityRelations,
} from '@backstage/plugin-catalog-react';
import { JsonObject } from '@backstage/types';

import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { AboutField } from './AboutField';

const useStyles = makeStyles({
  description: {
    wordBreak: 'break-word',
  },
});

export interface AboutContentProps {
  entity: Entity;
}

export function APIAboutContent(props: AboutContentProps) {
  const { entity } = props;
  const classes = useStyles();

  const gateway = entity.spec?.gateway as JsonObject;
  const gatewayName = gateway?.name as null | string;

  const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);
  return (
    <Grid container>
      <AboutField label="description" gridSizes={{ xs: 12 }}>
        <MarkdownContent
          className={classes.description}
          content={
            entity?.metadata?.description ||
            'No description provided for this entity'
          }
        />
      </AboutField>
      <AboutField
        label="owner"
        value="label"
        gridSizes={{ xs: 12, sm: 6, lg: 4 }}
      >
        {ownedByRelations.length > 0 && (
          <EntityRefLinks entityRefs={ownedByRelations} defaultKind="group" />
        )}
      </AboutField>

      <AboutField
        label="Lifecycle"
        value={entity?.spec?.lifecycle as string}
        gridSizes={{ xs: 12, sm: 6, lg: 4 }}
      />

      <AboutField
        label="tags"
        value="tags"
        gridSizes={{ xs: 12, sm: 6, lg: 4 }}
      >
        {(entity?.metadata?.tags || []).map(tag => (
          <Chip key={tag} size="small" label={tag} />
        ))}
      </AboutField>

      <AboutField label="Gateway" value={gatewayName ?? 'Unknown'} />
    </Grid>
  );
}
